import React from 'react';
import { useSiteSettings } from '../context/SiteSettingsContext';
import { assetUrl } from '../lib/api';

// Tightly cropped, transparent version of the Dry Ice Bulls logo.
const DEFAULT_LOGO_URL = '/logo-dry-ice-bulls.webp';

const sizes = {
    sm: { img: 'w-28', pill: 'px-2 py-1.5' },
    md: { img: 'w-40 sm:w-44', pill: 'px-3 py-2' },
    lg: { img: 'w-56', pill: 'px-4 py-3' },
    xl: { img: 'w-80', pill: 'px-6 py-4' },
};

// `plain` = on a light background (no pill). Otherwise a white pill keeps the black "BULLS" legible on dark.
export const Logo = ({ size = 'md', plain = false, className = '' }) => {
    const { settings } = useSiteSettings();
    const s = sizes[size];
    const customLogo = settings?.logo_url ? assetUrl(settings.logo_url) : null;
    const src = customLogo || DEFAULT_LOGO_URL;
    const noPill = plain || (customLogo && settings?.logo_transparent !== false);
    const img = <img src={src} alt="Dry Ice Bulls Cleaning System" className={`${s.img} h-auto object-contain block`} draggable={false} />;

    return (
        <div className={`inline-flex items-start ${className}`} data-testid="brand-logo">
            {noPill ? img : <div className={`bg-white ${s.pill} rounded-sm`}>{img}</div>}
            <sup className="text-[10px] font-bold text-brand-primary ml-0.5 -mt-0.5">®</sup>
        </div>
    );
};

export default Logo;
